document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
  const button = wrapper.querySelector('.custom-select-button');
  const options = wrapper.querySelector('.custom-select-options');
  const hiddenInput = wrapper.querySelector('input[type="hidden"]');

  // Toggle dropdown
  button.addEventListener('click', () => {
    options.style.display = options.style.display === 'block' ? 'none' : 'block';
  });

  // Select option
  options.querySelectorAll('li').forEach(option => {
    option.addEventListener('click', () => {
      button.childNodes[0].textContent = option.textContent; // update visible text
      hiddenInput.value = option.dataset.value; // update hidden input
      options.style.display = 'none';
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      options.style.display = 'none';
    }
  });
});

$('.popular-products-slider .product-grid, .glurb-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  dots:false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
  nextArrow: '<button class="slick-next" aria-label="Next"></button>',

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-tabs').forEach(tabsWrapper => {
    const tabs = tabsWrapper.querySelectorAll('.tab-btn');
    const panels = tabsWrapper.querySelectorAll('.tab-panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');
        tabsWrapper.querySelector(`#${target}`).classList.add('active');
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-tabs-desc').forEach(tabs => {
    const buttons = tabs.querySelectorAll('.tab-btn');
    const panels = tabs.querySelectorAll('.tab-panel');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;

        buttons.forEach(b => b.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        btn.classList.add('active');
        tabs.querySelector('#tab-' + target).classList.add('active');
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('productInquiry');
  const openBtn = document.querySelector('.product-inquiry-btn');
  const closeBtn = modal.querySelector('.modal-close');
  const overlay = modal.querySelector('.modal-overlay');

  openBtn?.addEventListener('click', () => {
    modal.classList.add('active');
  });

  [closeBtn, overlay].forEach(el => {
    el.addEventListener('click', () => {
      modal.classList.remove('active');
    });
  });
});


jQuery(document).ready(function($){
    $('.imageslider').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });


    $('.testi-slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      dots:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    $('.gallery-slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      dots:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next"></button>',

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    $('.glurb-slider').slick({
      dots: true,
      infinite: false,
      speed: 300,
      dots:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev" aria-label="Previous"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next"></button>',

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
    document.querySelectorAll('.custom-select').forEach(select => {
    const trigger = select.querySelector('.select-trigger');
    const options = select.querySelector('.select-options');
    const valueInput = select.querySelector('input');
    const label = trigger.querySelector('span');

    trigger.addEventListener('click', () => {
      options.style.display = options.style.display === 'block' ? 'none' : 'block';
    });

    options.querySelectorAll('li').forEach(option => {
      option.addEventListener('click', () => {
        label.textContent = option.textContent;
        valueInput.value = option.dataset.value;
        options.style.display = 'none';
      });
    });

    document.addEventListener('click', e => {
      if (!select.contains(e.target)) {
        options.style.display = 'none';
      }
    });
  });

});

$(function () {
    const mediaQuery = window.matchMedia("(max-width: 989px)");

    function moveCart(e) {
        if (e.matches) {
            // screen ≤ 989px
            $(".menu-cart-bottom").appendTo(".header-middle-cust");
        }
    }

    // Run on load
    moveCart(mediaQuery);

    // Run on resize
    mediaQuery.addEventListener("change", moveCart);
});

// Function to check mobile screen
function isMobile() {
  return window.innerWidth <= 749;
}

// OPEN FACET (on disclosure click)
$(document).on('click', '.mobile-facets__disclosure', function (e) {
  if (!isMobile()) return; // Only run on mobile

  e.stopImmediatePropagation(); // stop Dawn from re-adding classes

  const $details = $(this).find('.mobile-facets__details');
  const $wrapper = $('#FacetsWrapperMobile');

  // Wrapper state
  $wrapper.addClass('submenu-open');

  // Details state
  $details
    .addClass('menu-opening')
    .attr('open', '');

  // Summary ARIA
  $details
    .find('.mobile-facets__summary')
    .attr('aria-expanded', 'true');
});

// CLOSE FACET (on close button click)
$(document).on('click', '.mobile-facets__close-button', function (e) {
  if (!isMobile()) return; // Only run on mobile

  e.stopImmediatePropagation();

  const $details = $(this).closest('.mobile-facets__details');
  const $wrapper = $('#FacetsWrapperMobile');

  // Remove wrapper state
  $wrapper.removeClass('submenu-open');

  // Reset details
  $details
    .removeClass('menu-opening')
    .removeAttr('open');

  // Reset summary ARIA
  $details
    .find('.mobile-facets__summary')
    .attr('aria-expanded', 'false');
});

// SUMMARY TOGGLE (manual control)
$(document).on('click', '.mobile-facets__summary', function (e) {
  if (!isMobile()) return; // Only run on mobile

  e.preventDefault(); // stop native toggle
  e.stopImmediatePropagation(); // stop Dawn's JS

  const $details = $(this).closest('.mobile-facets__details');

  // Toggle open manually
  if ($details.attr('open')) {
    $details.removeAttr('open').removeClass('menu-opening');
    $(this).attr('aria-expanded', 'false');
  } else {
    $details.attr('open', '').addClass('menu-opening');
    $(this).attr('aria-expanded', 'true');
  }
});
// Original Bundler price logic as a function
function updateBundlerPrices() {
  var regularPriceText = $('.price-item--regular').first().text();
  var cleanPrice = parseFloat(regularPriceText.replace(/[^\d.]/g, ''));

  if (!cleanPrice) return;

  $('.bndlr-radio-container').each(function () {

    // Get quantity from "Buy X..."
    var buyText = $(this).find('.bndlr-text').text();
    var quantity = parseInt(buyText.replace(/[^\d]/g, '')) || 1;

    // Total before discount
    var totalPrice = cleanPrice * quantity;

    // Discount %
    var savingsText = $(this).find('.bndlr-savings-text').text();
    var discountPercent = parseFloat(savingsText.replace(/[^\d.]/g, '')) || 0;

    // Final price after discount
    var finalPrice = totalPrice - (totalPrice * discountPercent / 100);

    // Format values
    totalPrice = totalPrice.toFixed(2);
    finalPrice = finalPrice.toFixed(2);

    // Show like: US$ 313.00
    $(this).find('.bndlr-original-price').text('US$ ' + totalPrice);
    $(this).find('.bndlr-discounted-price').text('US$ ' + finalPrice);

  });
}

// --- Trigger logic when a selectCustom option is clicked ---
$(document).on('click', '.selectCustom-option', function () {
  const $option = $(this);
  const $mwOption = $option.closest('.mw-option');

  const valueId = $option.data('value') || '';
  const valueText = $option.text().trim();

  // console.log('Option clicked:', valueText, valueId);

  // Update underlying <select> so any native change triggers also work
  const $select = $mwOption.find('select.mw-option__control--type-select');
  $select.val(valueId).trigger('change');

  // Run Bundler price logic
  updateBundlerPrices();
});

// --- Optional: Also trigger if native select ever changes (fallback) ---
$(document).on('change', '.mw-option__control--type-select', function () {
  updateBundlerPrices();
});
